import { useMutation } from 'react-query';
import { shiftApplicationService } from 'hq/services';
import {
  BulkAcceptShiftApplicationOptions,
  BulkAcceptShiftApplicationParams,
} from '../use-bulk-accept-shift-applications.types';

const useHqBulkAcceptShiftApplications = (options: BulkAcceptShiftApplicationOptions) => {
  const mutationFn = async (params: BulkAcceptShiftApplicationParams) =>
    await shiftApplicationService.bulkAcceptShiftApplications(params);

  return useMutation(mutationFn, options);
};

export { useHqBulkAcceptShiftApplications };
